module.exports = __webpack_public_path__ + "img/esquina.b0208f36.svg";